import { APP_STORAGE_KEYS } from '@/core/enums/app.enum';
import { RECONNECT_SOCKET_EVENT, _APP_STORE } from '@/core/values/app.values';
import { OFFLINE_MODE_EVENT } from '@/core/values/core.values';
import { LocalStorageService } from '@/services/local-storage.service';
import { ScreenMirroringService } from '@/services/screen.mirroring.service';
import { SCREEN_MIRRORING_EVENTS, SCREEN_MIRRORING_MESSAGE_TYPE } from '@/values/screen.mirroring.values';
import { Component , Vue } from 'vue-property-decorator';
import { SCREEN_MIRRORING_STORE } from '../store/screen-mirroring.store';

@Component({})
export class ScreenMirroringMixin extends Vue {

  public hasSession: boolean = false;

  get userId() {
    return this.$store.state.AuthStore.user.userId;
  }

  get isStudent() {
    return this.$store.getters['AuthStore/isStudent'];
  }

  get presentationSocketConnected(): boolean {
    return this.$store.state.AppStore.presentationSocketConnected;
  }

  get clientId() {
    return this.$store.state.ScreenMirroringStore.clientId;
  }

  get userMode() {
    return this.$store.state.AppStore.userMode;
  }

  get userModeForScreenMirroring() {
    return this.$store.state.AppStore.userMode;
  }

  get isScreenMirroringActive() {
    return this.$store.state.AppStore.userMode == 'book' || this.$store.state.AppStore.userMode == 'paper';
  }

  get isScreenMirroringBookModeActive() {
    return this.$store.state.AppStore.userMode == 'book';
  }

  get isScreenMirroringPaperModeActive() {
    return this.$store.state.AppStore.userMode == 'paper';
  }

  initScreenMirroring() {
    if(this.isStudent) {

      window.addEventListener('beforeunload', this.disconnectUser);
      const localUserMode: string = LocalStorageService.getItem(APP_STORAGE_KEYS.STUDENT_MODE);
    
      if(!this.clientId) {
        this.$store.commit(
          SCREEN_MIRRORING_STORE.MUTATIONS.SET_CLIENT_ID,
          Date.now().toString()
        );
      }
      
      this.$edEventBus.$off(SCREEN_MIRRORING_EVENTS.LOAD_ALL_MESSAGES, this.onMessages);
      this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.LOAD_ALL_MESSAGES, this.onMessages);

      this.$edEventBus.$off(SCREEN_MIRRORING_EVENTS.GO_TO_PAGE, this.goToPage);
      this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.GO_TO_PAGE, this.goToPage);

      this.$edEventBus.$off(SCREEN_MIRRORING_EVENTS.CLICK, ScreenMirroringService.emitScreenMirroringEvent);
      this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.CLICK, ScreenMirroringService.emitScreenMirroringEvent);

      this.$edEventBus.$off(RECONNECT_SOCKET_EVENT, this.onReconnectSocket);
      this.$edEventBus.$on(RECONNECT_SOCKET_EVENT, this.onReconnectSocket);

      this.$edEventBus.$off(OFFLINE_MODE_EVENT, this.onUserIsOffline);
      this.$edEventBus.$on(OFFLINE_MODE_EVENT, this.onUserIsOffline);
      
      
      if(!localUserMode) {
        this.setModeNormal(false);
        ScreenMirroringService.emitScreenMirroringEvent(this, {}, 'list');
      } else {
        this.hasSession = true;
        this.setMode(localUserMode.toLowerCase());
      }
    }
  }

  onMessages(message: any) {
    const isMessageAccepted = [
      SCREEN_MIRRORING_MESSAGE_TYPE.LIST_RESPONSE,
      SCREEN_MIRRORING_MESSAGE_TYPE.CONNECT_RESPONSE,
      SCREEN_MIRRORING_MESSAGE_TYPE.CLICK_RESPONSE,
      SCREEN_MIRRORING_MESSAGE_TYPE.DISCONNECT_RESPONSE
    ].includes(message.messageType);

    if(isMessageAccepted) {

      let content = JSON.parse(message.content);
      let clientId = this.$store.state.ScreenMirroringStore.clientId;
      
      if(clientId === content.clientId) {
        if (message.messageType === SCREEN_MIRRORING_MESSAGE_TYPE.LIST_RESPONSE && !this.hasSession) {
          ScreenMirroringService.handleScreenModeValidation(this, message);
        }
        
        /* Mode changed */
        if(message.messageType === SCREEN_MIRRORING_MESSAGE_TYPE.CONNECT_RESPONSE) {
          ScreenMirroringService.screenModeSelection(this, content.mode, false);
          this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.SYNCHRONIZE_SCREENS, content);
        }
  
        if(message.messageType === SCREEN_MIRRORING_MESSAGE_TYPE.CLICK_RESPONSE) {
          if(this.$store.state.AppStore.userMode !== 'normal') {
            this.$edEventBus.$emit(content.target, content);
          }
        }

      }

      if (message.messageType === SCREEN_MIRRORING_MESSAGE_TYPE.DISCONNECT_RESPONSE) {
        ScreenMirroringService.screenModeSelection(this, 'normal', false);
      }

    }
  }

  setMode(mode: string, notifyToBackend: boolean = true) {
    ScreenMirroringService.screenModeSelection(this, mode, notifyToBackend);
  }

  setModeNormal(notifyToBackend: boolean = true) {
    ScreenMirroringService.screenModeSelection(this, 'normal', notifyToBackend);
  }

  goToPage(data) {
    this.$router.push({ 
      name: data.name,
      params: data.params  
    }).catch(() => {});

    //close any opened modal
    this.$EdModal.closeModal();
    this.$EdModal.closeConfirmationModal();
  }

  disconnectUser() {
    ScreenMirroringService.emitScreenMirroringEvent(
      this,
      { userAgent: navigator.userAgent },
      SCREEN_MIRRORING_MESSAGE_TYPE.DISCONNECT_USER_REQUEST
    );
  }


  onReconnectSocket() {
    let isNormalModeSelected = this.userMode == 'normal';
    this.setMode(this.userMode, !isNormalModeSelected);
    if( !isNormalModeSelected ) {
      this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.ON_WSSOCKET_RECONNECTION);
    }
  }

  onUserIsOffline(offline) {
    if( offline ) {
      this.setModeNormal(false);
    }
  }

}
